import React from 'react';
import { Box } from '@chakra-ui/react';
import Scheduler from '../Components/Scheduler';

function Content() {
  return (
    <Box>
      <Box m="2" p="2">
        <Scheduler />
      </Box>
    </Box>
  );
}

export default Content;
